export default __webpack_public_path__ + "static/media/Camera_Off.8880bae6.svg";